//Formik
import FormikCheckboxInput from "../../../helpers/formikInputs/FormikCheckboxInput"
import FormikRadioButtonInput from "../../../helpers/formikInputs/FormikRadioButtonInput"

//styling
import myStyles from "../../../styles/assessments/AssessmentForm.module.css"

export default function AssessmentFormQuestionMatrixOption({
  label,
  option,
  answers,
  valueFieldName,
  question,
  readOnly,
}) {
  const answer = answers.find((answer) => answer.questionId === label.id)

  if (!answer) {
    return <>answer not found</>
  } else {
    const answerIndex = answers.indexOf(answer)
    let valueName = `answers[${answerIndex}].${valueFieldName}`

    if (answer.type === "matrixcheckbox") {
      const multiValueEntry = answer.multiValues.find(
        (value) => value.optionId === option.id
      )
      const multiValueIndex = answer.multiValues.indexOf(multiValueEntry)

      if (multiValueEntry) {
        valueName = `answers[${answerIndex}].multiValues[${multiValueIndex}].${valueFieldName}`
      } else {
        return <>answer not found</>
      }
    }

    return (
      <div className={myStyles.matrixQuestionOption}>
        {question.type === "matrix" ? (
          <FormikRadioButtonInput
            name={valueName}
            options={[{ text: "", optionId: option.id }]}
            optionLabel={"text"}
            optionValue={"optionId"}
            disabled={readOnly}
            className={myStyles.matrixQuestionOptionRadio}
          />
        ) : (
          <FormikCheckboxInput
            checkboxLabel={""}
            name={valueName}
            disabled={readOnly}
          />
        )}
      </div>
    )
  }
}
